// extracted by mini-css-extract-plugin
export var divider = "_ss-0";
export var systemMessage = "_ss-1";